@use 'styles/colors' as *;
@use 'styles/functions/rem' as *;
@use 'styles/mixins/fonts' as *;

.closed {
    display: none;
}

.closeButton {
    color: $notificationCloseButtonColor;
    margin-right: rem(30px);
}

.baseNotificationContainer {
    align-items: center;
    border-radius: rem(8px);
    display: flex;
    justify-content: space-between;
    width: 100%;
}

.iconTextContainer {
    align-items: center;
    gap: rem(16px);
    margin-left: rem(21px);
}

.iconContainer {
    height: rem(18px);
    width: rem(18px);
}

.notificationText {
    @include largeSemiboldFont;

    color: $notificationTextColor;
    text-align: left;
}
